import React from 'react'
import { Col, Container, Row } from 'react-bootstrap'
import Home from './Home'
import './Design.css'
import { FaHandPointRight } from "react-icons/fa6"
export default function AboutMe() {
  return (
    <div>
      <section>
        <Container className='about-myself'>
          <Home />
          <Container className='about-myself-content'>
            <Row>
              <Col md={7} className='left-section'>
                <h1 className="about-myself-heading">KNOW MORE ABOUT ME</h1>
                <br />
                <p>Hello, I'm Deepali, a student currently pursuing a Bachelor of Technology (B.Tech)
                  degree at IP University. I'm passionate about the field of technology and constantly
                  strive to expand my knowledge and skills in this ever-evolving domain.Iam looking forward to
                  exploring and contributing to the world
                  of engineering and technology.</p>
                <br />
                <div className='education'>
                  <h4 className='education-heading'>My education</h4>
                  <br />
                  <ul className='education-list'>
                    <li>Class 10<sup>th</sup> 👩 from Nalanda Modern Public School
                      <br />
                      Percentage:77.5%
                    </li>
                    <br />
                    <li>Class 12<sup>th</sup> 👩 from Nalanda Modern Public School
                      <br />
                      Percentage:80%
                    </li>
                    <br />
                    <li>B.Tech(CSE) 👩‍🎓 from Guru Gobind Singh Indraprastha University
                      <br />
                      CGPA:9.06 (2020-2024)
                    </li>
                  </ul>
                </div>
              </Col>
              <Col md={5} className='right-section'>
                <img src='about.png' alt='' style={{ width: '100%' }}></img>
              </Col>
            </Row>
            <div className='experience'>
              <Row>
                <Col md={5}>
                  <img src='study.jpg' alt='' className='experience-img'></img>
                </Col>
                <Col md={7}>
                  <h2 className='my-experience'>
                    Experience
                  </h2>
                  <p className='about-internship'>During my internship at B2World, a  startup IT company, I assumed the role of
                    a full-stack web developer. Over the course of my tenure, I spearheaded the development
                    of their official website from inception to completion. Leveraging my skills in both
                    front-end and back-end development, I ensured a seamless user experience
                    while implementing innovative features to enhance functionality. Collaborating
                    closely with the team, I integrated cutting-edge technologies to create a
                    responsive and visually appealing website that accurately reflected B2World's brand identity.
                    This experience not only honed my technical prowess but also instilled in me a
                    deep understanding of the intricate workings of a startup environment.</p>
                  <p>
                    <FaHandPointRight className='hand-icon' />
                    Certificate: <a href='internship-certificate.png' target=' 
                      ' className='custom-link'>Link</a>
                  </p>
                  <p>
                    <FaHandPointRight className='hand-icon' />
                    Website Link: <a href='https://b2world.tech/' target=' ' className='custom-link'>Link</a>
                  </p>
                </Col>
              </Row>
              <Row className='mt-4'>
              <h2 className='my-experience'>
                    Experience
                  </h2>
                <Col md={7} className='mr-20' >
                  <p className='about-internship'>During my two-month internship at Neophyte Consulting Service,
                     I worked as a React.js intern, focusing on creating robust web applications using Next.js
                      and Tailwind CSS. I was responsible for developing dynamic features and responsive layouts,
                       leveraging Next.js for server-side rendering and static site generation to enhance performance. 
                       With Tailwind CSS, I designed modern and visually appealing interfaces, ensuring a seamless 
                       user experience. This role allowed me to refine my technical skills and collaborate effectively 
                       with a team, contributing to the successful delivery of high-quality web applications. Additionally, 
                       I gained valuable experience in optimizing application performance and implementing best practices 
                       in modern web development.</p>
                  <p>
                    <FaHandPointRight className='hand-icon' />
                    Certificate: <a href='Internship-Certificate-Deepali-Sardana.pdf' target=' 
                      ' className='custom-link'>Link</a>
                  </p>
                </Col>
                <Col md={5} className='custom-inline'>
                  <img src='experience2.png' alt='' className='experience-img'></img>
                </Col>
              </Row>
            </div>
          </Container>
        </Container>
      </section>
    </div>
  )
}

